/*
 * Public API Surface of ngx-logger
 */

export * from './lib/logger.barrel';
